import React from 'react'

import SchemaArray from './SchemaArray'
import { Field, FieldArray, FormSection } from 'redux-form'
import { TextInput, Select, Checkbox, NumericInput } from '../../../components/forms/index'

const SchemaObject = ({ title, schema = {} }) => {
  let { properties, required } = schema
  let props = Object.keys(properties)
  
  return (
    <div className='schema-form-block'>
      {props.map(key => {
        let prop = properties[key]
        switch (prop.type) {
          case 'object':
            let isNestedRequire = required && required.includes(prop.name)
            return (
              <FormSection key={prop.id} name={prop.id}>
                <Field name='_include' className='ncss-label' label={prop.title} disabled={isNestedRequire} component={Checkbox} title={prop.description} />
                <SchemaObject title={prop.title} schema={prop} />
              </FormSection>
            )
          case 'string':
            return prop.enum
              ? <Field key={prop.id} name={prop.id} component={Select} label={prop.title} options={prop.enum.map(e => ({ label: e, value: e }))} title={prop.description} />
              : <Field key={prop.id} name={prop.id} component={TextInput} label={prop.title} title={prop.description} placeholder={prop['x-placeholder']} />
          case 'text':
              return <Field key={prop.id} name={prop.id} component={TextInput} textArea label={prop.title} title={prop.description} placeholder={prop['x-placeholder']} />
          case 'boolean':
            return <Field key={prop.id} name={prop.id} component={Checkbox} label={prop.title} title={prop.description} />
          case 'array':
            return <FieldArray key={prop.id} name={prop.id} prop={prop} component={SchemaArray} />
          case 'number':
            return <Field key={prop.id} name={prop.id} component={NumericInput} label={prop.title} title={prop.description} />
          default:
            throw new Error(`unknown prop type ${prop.type} in ${title}`)
        }
      })}
    </div>
  )
}

export default SchemaObject

// TODO: make updates so that when viewing an existing issues the fields are by defualt read only and have an Edit button next to them, may require a new component


// WEBPACK FOOTER //
// ./client/src/serviceDesk/request/forms/SchemaObject.js